import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConfirmarSolicitacaoSuperSocialPage } from './confirmar-solicitacao-super-social.page';

const routes: Routes = [{ path: '', component: ConfirmarSolicitacaoSuperSocialPage }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConfirmarSolicitacaoSuperSocialRoutingModule { }
